import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { useEffect, useState } from "react";
import { User } from "oidc-client-ts";

import AdvancePaymentForm from "../components/AdvancePaymentForm";
import RefundReportView from "../components/RefundReportView";
import ReportEntryForm from "../components/ReportEntryForm";
import Header from "../components/molecules/Header";
import Loading from "../components/atoms/Loading";
import Collaborator from "../@types/Collaborator";
import { fetchUser } from "../service/user";
import { oidcConfig } from "../config";
import { api } from "../service/api";

const AppRouter = () => {
  const [userAccount, setUserAccount] = useState<Collaborator>();
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  const RequestUserAccount = async () => {
    await fetchUser()
      .then((response) => {
        setUserAccount(response);
      })
      .catch((error) => {
        console.error("Error getting user account:", error);
      });
  };

  useEffect(() => {
    if (!auth.isAuthenticated && !auth.isLoading && !hasTriedSignin) {
      auth.signinRedirect();
      setHasTriedSignin(true);
    } else if (auth.isAuthenticated) {
      RequestUserAccount();
    }
  }, [auth, hasTriedSignin]);

  useEffect(() => {
    return auth.events.addAccessTokenExpiring(() => {
      const oidcStorage = localStorage.getItem(`oidc.user:${oidcConfig.authority}:${oidcConfig.client_id}`);
      if (oidcStorage)
        api.defaults.headers.Authorization = `Bearer ${User.fromStorageString(oidcStorage).access_token}`;
    });
  }, [auth.events, auth.signinSilent]);

  if (auth.isLoading && !userAccount) {
    return <Loading />;
  }

  if (auth.error) {
    return <div>Oops... {auth.error.message}</div>;
  }

  return (
    <Router>
      <Header account={userAccount} />
      <Routes>
        <Route
          path="/"
          key="home"
          element={
            userAccount && (
              <RefundReportView
                account={userAccount}
                groupByCollaborator={false}
                selfRefundsOnly={true}
                title="Meus Reembolsos"
                showTotalValue={true}
                showExportFilesButtons={false}
                showSendToButtons={false}
                showAddReportEntryButton={true}
              />
            )
          }
        />

        <Route
          path="/approvals"
          key="approvals"
          element={
            userAccount ? (
              <RefundReportView
                account={userAccount}
                groupByCollaborator={true}
                selfRefundsOnly={false}
                title=""
                showTotalValue={false}
                showExportFilesButtons={false}
                showSendToButtons={false}
                showAddReportEntryButton={false}
                includeAdvances={false}
              />
            ) : (
              <div>Carregando...</div>
            )
          }
        />

        <Route
          path="/search"
          key="search"
          element={
            userAccount ? (
              <RefundReportView
                account={userAccount}
                groupByCollaborator={false}
                selfRefundsOnly={false}
                title="Reembolsos e Adiantamentos"
                showTotalValue={false}
                showExportFilesButtons={true}
                showSendToButtons={true}
                showAddReportEntryButton={false}
                includeAdvances={false}
              />
            ) : (
              <div>Carregando...</div>
            )
          }
        />

        <Route
          path="/new_request"
          key="new_request"
          element={userAccount && <ReportEntryForm account={userAccount} />}
        />

        <Route
          path="/edit_request"
          key="edit_request"
          element={userAccount && <ReportEntryForm account={userAccount} />}
        />

        <Route
          path="/new_advance_payment"
          key="new_advance_payment"
          element={userAccount && <AdvancePaymentForm account={userAccount} />}
        />

        <Route
          path="/edit_advance_payment"
          key="edit_advance_payment"
          element={userAccount && <AdvancePaymentForm account={userAccount} />}
        />
      </Routes>
    </Router>
  );
};

export default AppRouter;
